import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  browserMode: sessionStorage.getItem('browserMode') || null,
};

const menusSlice = createSlice({
  name: 'menus',
  initialState,
  reducers: {
    setBrowserMode(state, action) {
      sessionStorage.setItem('browserMode', action.payload);
      state.browserMode = action.payload;
    },
  },
});

export const { setBrowserMode } = menusSlice.actions;
export default menusSlice.reducer;
